import { Federation } from 'app/shared/models/class/federation/federation';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClubDetails, CodeClub, LegalNotice, SessionByClub } from 'app/shared/models/class/club/club';
import { ClubRessource } from 'app/shared/models/class/resource/resource';
import { CustomerCounter } from 'app/shared/models/class/user/user';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ClubService {
  clubDetails: ClubDetails[] = [];

  resources: ClubRessource[] = [
    new ClubRessource('C59045', 'Doe', 'John', 'Jo'),
    new ClubRessource('C59045', 'Doe', 'Thomas', 'Tom'),
    new ClubRessource('C59045', 'Doe', 'Olivier', 'Kersauson'),
    new ClubRessource('C59045', 'Doe', 'François', 'Gabart'),
  ];

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getClubs(): Observable<CodeClub[]> {
    return this.http.get<CodeClub[]>(`${environment.apiUrl}/Club/ClubCodes`);
  }

  getClubDetails(): Observable<ClubDetails[]> {
    return this.http.get<ClubDetails[]>(`${environment.apiUrl}/Club/ClubsDetails`)
    .pipe(
      map(clubDetails => {
        this.clubDetails = clubDetails.map(club => ClubDetails.fromObject(club));
        return [...this.clubDetails];
      })
    );
  }

  getAllRessourceByClub(clubCode: string): Observable<ClubRessource[]> {
    return this.http.get<ClubRessource[]>(`${environment.apiUrl}/Club/Ressource/${clubCode}`);
  }

  getCustomersByClub(clubCode: string): Observable<CustomerCounter[]> {
    return this.http.get<CustomerCounter[]>(`${environment.apiUrl}/Club/ClubUsers/${clubCode}`);
  }

  getCGV(clubCode: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Club/CGV/${clubCode}`);
  }

  getCGVBlob(clubCode: string) {
    return this.http.get(`${environment.apiUrl}/Club/CGV/${clubCode}`, { observe: 'response', responseType: 'blob' });
}

  getCGVBlob2(clubCode: string) {
    return this.http.get(`${environment.apiUrl}/Club/CGV/${clubCode}`, { observe: 'response', responseType: 'blob' })
    .pipe(map(res => this.saveFile(res)));
}

  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    return res.body;
  }

  getSessionsByClub(clubCode: string): Observable<SessionByClub[]> {
    return this.http.get<SessionByClub[]>(`${environment.apiUrl}/Club/Sessions/${clubCode}`);
  }

  getLegalNoticesByClub(clubCode: string): Observable<LegalNotice> {
    return this.http.get<LegalNotice>(`${environment.apiUrl}/Club/LegalNotice/${clubCode}`);
  }

  getAllImagesByClub(clubCode: string): Observable<ClubRessource[]> {
    return this.http.get<ClubRessource[]>(`${environment.apiUrl}/Club/CloudImage/${clubCode}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addClub(club: ClubDetails) {
    const formData = new FormData();
    formData.append('clubString', JSON.stringify(club));

    return this.http.post(`${environment.apiUrl}/Club/NewClub`, formData);
  }

  addResource(resource: ClubRessource) {
    return this.http.post(`${environment.apiUrl}/Club/Ressource`, resource);
  }

  uploadCGV(clubCode: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post(`${environment.apiUrl}/Club/CGV/${clubCode}`, formData);
  }

  uploadLogo(clubKey: number, file: File) {
    const formData = new FormData();
    if (file) { formData.append('file', file, file.name); }

    const requestOptions: object = { responseType: 'text' };

    return this.http.post<any>(`${environment.apiUrl}/Club/UploadLogo?clubKey=${clubKey}`, formData, requestOptions);

  }

  updateLegalNotices(legalNotices: LegalNotice) {
    return this.http.post<LegalNotice>(`${environment.apiUrl}/Club/LegalNotice`, legalNotices);
  }


  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateClub(club: ClubDetails) {
    const formData = new FormData();
    formData.append('clubString', JSON.stringify(club));

    return this.http.put(`${environment.apiUrl}/Club/UpdateClub`, formData);
  }

  updateResource(resource: ClubRessource) {
    return this.http.put(`${environment.apiUrl}/Club/Ressource`, resource);
  }

  upDateCGV(clubCode: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.put(`${environment.apiUrl}/Club/CGV/${clubCode}`, formData);
  }

}
